import { z } from "zod";
import { toast } from "../components/ui/use-toast";
import api from "./api";
import { BASE_URL } from "./auth";

const inputSchema = z.object({
  name: z.string().default("Untitled"),
  description: z.string().optional().default(""),
  google_document_link: z.string(),
  document_type: z.enum(["template", "library"]).optional().default("template"),
  platform: z.enum(["google", "ppt"]),
  reset_text_boxes: z.boolean(),
});

export async function createTemplate(
  data: Partial<z.infer<typeof inputSchema>>
) {
  try {
    const result = inputSchema.safeParse(data);
    if (!result.success) {
      throw new Error(result.error.errors[0].message);
    }
    // @ts-ignore
    result.data.reset_text_boxes = result.data.reset_text_boxes
      ? "true"
      : "false";

    const response = await api.post(
      `${BASE_URL}/documents/${
        result.data.platform
        // @ts-ignore
      }?${new URLSearchParams(result.data).toString()}`,
      null,
      { timeout: 0 }
    );

    if (response.status !== 200) {
      if (response.data && "detail" in response.data) {
        if (typeof response.data.detail === "string")
          throw new Error(response.data.detail);
        if (typeof response.data.detail === "object")
          throw new Error(response.data.detail[0]);
      }
      throw new Error("Failed to create template");
    }
    return response.data;
  } catch (error: any) {
    console.error("Failed to create template:", error);
    toast({
      title: "Failed to create template",
      description: "Unable to create template",
    });
    return null;
  }
}
